import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { CbUserDateTimeModule } from '../user-date-time/user-date-time.module';
import { CbDialogModule } from '../dialog/dialog.module';
import { CbFormsModule } from '../forms/forms.module';
import { FormsModule } from '@angular/forms';
import { CbClickModule } from '@app/shared/directives/click/click.module';
import { CbDisplayValueModule } from '../display-value/display-value.module';
import { CbSortByModule } from '@app/shared/pipe/sort-by/sort-by.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CbCurrencyModule } from '@app/shared/pipe/currency/currency.module';
import { CbInfoMessageModule } from 'cb-hub-lib';
import { AiRateResponseDialogComponent } from '@app/shared/components/ai-rate/ai-rate-response-dialog/ai-rate-response-dialog.component';



@NgModule({
    declarations: [AiRateResponseDialogComponent],
    exports: [],
    imports: [
        CommonModule,
        FormsModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        CbUserDateTimeModule,
        CbDialogModule,
        CbFormsModule,
        CbClickModule,
        CbDisplayValueModule,
        CbSortByModule,
        CbCurrencyModule,
        MatMenuModule,
        MatCardModule,
        MatTooltipModule,
        CbInfoMessageModule,
    ]
})
export class CbAiRateModule { }
